module.exports = __webpack_public_path__ + "./images/7833a0d4c2ee8d5a9828a4703547ad71.jpg";